import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import {hasClass, addClass,removeClass} from '../utils/domUtils';
import translate from '../../i18n/translate';

class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.clear = this.clear.bind(this);
        this.clearResults = this.clearResults.bind(this);
        this._debouncedSearch = _.debounce(this.search,300);
    }

    componentDidMount(){
        var searchBar = ReactDOM.findDOMNode(this);
        var input = searchBar.querySelector('input');
        var clearIcon = searchBar.querySelector('.search-clear');
        input.addEventListener('keyup', this._debouncedSearch);
        clearIcon.addEventListener('click',this.clear);
    }

    componentWillUnmount(){
        var searchBar = ReactDOM.findDOMNode(this);
        var input = searchBar.querySelector('input');
        var clearIcon = searchBar.querySelector('.search-clear');
        input.removeEventListener('keyup', this._debouncedSearch);
        clearIcon.removeEventListener('click',this.clear);
    }

    search(e){
        var searchBar = ReactDOM.findDOMNode(this);
        var inputValue = e.target.value;
        if(inputValue !== ''){
            this.props.onValueChaged(inputValue);
            var clearIcon = searchBar.querySelector('.search-clear');
            if(hasClass(clearIcon,'hide')){
                removeClass(clearIcon,'hide');
            }
        }else{
            this.clearResults();
        }
    }



    clear(e){
        e.preventDefault();
        this.clearResults();
    }
    clearResults(){
        var searchBar = ReactDOM.findDOMNode(this);
        var input = searchBar.querySelector('input');
        input.value = '';
        this.props.onValueChaged('');
        var clearIcon = searchBar.querySelector('.search-clear');
        addClass(clearIcon,'hide');
    }

    render() {
        const className ='search '+ (this.props.className||'');
        return (
           <section className={className}>
               <label><i className="gc gc-search"></i></label>
               <input className="form-control input-lg" placeholder={this.props.strings.searchPlaceHolder}  />
               <a href="#" className="search-clear fa fa-times-circle hide"></a>
           </section>
        );
    }
}

SearchBar.defaultProps = {
    strings: {}
};

export default translate('Searchbar')(SearchBar)



// WEBPACK FOOTER //
// ./client/components/SearchBar.js